type Props = { name: string; feedback: string };

export default function TestimonialCard({ name, feedback }: Props) {
    return (
        <div className="bg-white p-6 rounded-lg shadow">
            <p className="text-gray-600">“{feedback}”</p>
            <h4 className="mt-4 font-semibold text-blue-600">{name}</h4>
        </div>
    );
}
